__turbopack_context__.v({
  "select": "selectField-module-scss-module__vpX8UG__select",
});
